import type { Components, Theme } from '@mui/material/styles';

export const menuTheme: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    root: {
      background: 'unset'
    },
    list: {
      boxShadow: '0px 5px 20px 2px rgba(44, 58, 66, 0.15)',
      borderRadius: '8px'
    }
  }
};
